<template>
  <div class="addcar heightestZindex">
    <div class="addCarBox" v-if="showTypeOne==2">
      <div class="samllHeader" v-show="false">
        <i class="backIcon backIcon2" @click="showTypeOne=1"></i>
        <h1 class="titleName">添加车辆</h1>
      </div>
      <div class="addContent">
        <img src="@/assets/images/becomeOwner/car_banner.png">
        <div class="carInfo">
          <h3 class="carItemTitle">车主信息</h3>
          <div class="carItem">
            <h6>姓名</h6>
            <p><input class="textRight" type="text" v-model="ownerName" maxlength="12" placeholder="请输入车主姓名" :disabled="isdisabled" :readonly="isdisabled"></p>
          </div>
          <div class="carItem">
            <h6>手机号</h6>
            <p><input class="textRight" type="tel" :value="ownerPhone" maxlength="11" placeholder="请输入车主联系方式" disabled></p>
          </div>
          <h3 class="carItemTitle">车辆信息</h3>
          <div class="carItem">
            <h6>车牌号</h6>
            <p><input class="textRight" type="text" v-model="carCard" maxlength="8" placeholder="请输入(例鄂A88888)"></p>
          </div>
          <div class="carItem">
            <h6>品牌车型</h6>
            <p><input class="textRight" type="text" v-model="carBrand" placeholder="请输入(例宝马X6 2017款)"></p>
          </div>
          <div class="carItem" @click="ChoiceCity()">
            <h6>上线城市</h6>
            <p class="hasIcon"><input class="textRight" type="text" v-model="carCity" placeholder="请选择上线城市" readonly></p>
          </div>
          <div class="carItem" @click="ChoiceAddress()">
            <h6>上线地址</h6>
            <p class="hasIcon"><input class="textRight" type="text" v-model="carAddress" placeholder="请选择地址" readonly></p>
          </div>
          <div class="carItem">
            <h6>邀请人手机号</h6>
            <p><input class="textRight" type="text" v-model="RefereePhone" placeholder="请输入邀请人手机号码" maxlength="11"></p>
          </div>
        </div>
        <div class="addSunmit" v-on:click="submitApply">提交申请</div>
      </div>
    </div>
    <div class="addCarResult" v-if="showTypeOne==3">
      <div class="samllHeader" v-if="false">
        <i class="backIcon backIcon2" @click="showTypeOne=1"></i>
        <h1 class="titleName">提交成功</h1>
      </div>
      <div class="successBox">
        <img class="successBg" src="@/assets/images/becomeOwner/success.png">
        <p class="successTips">恭喜你 提交成功！</p>
        <p class="allTips">工作人员将在24小时内审核您的资料</p>
        <div class="backBtn" @click="gorent()">返回首页</div>
      </div>
    </div>
  </div>
</template>

<script>
  /*组件方式引用*/
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { orderSource} from "@/utils/env";

  import { apply } from '@/utils/api';
  export default {
    name: 'becomeOwner',
    components: {swiper, swiperSlide},
    data() {
      return {
        showTypeOne: 2,
        ownerName: '',
        ownerPhone: '',
        carCard: '',
        carBrand: '',
        carCity: '',
        carAddress: '',
        RefereePhone: '',
        ownerCity: '',
        ownerAdd: '',
        Longitude: '',
        Latitude: '',
        isdisabled:false
      }
    },
    watch: {
      ownerPhone (val, oldVal) {
        //this.ownerPhone = this.onlyNum(val)
      },
      RefereePhone (val, oldVal) {
        this.RefereePhone = this.onlyNum(val)
      }
    },
    created () {
      if(this.$route.query.showTypeOne){
        this.showTypeOne=this.$route.query.showTypeOne;
      }
      this.carCity=localStorage.getItem('shareCarCity') || '';
      if(localStorage.getItem('shareCarAddress')){
        this.carAddress=JSON.parse(localStorage.getItem('shareCarAddress')).Address|| '';
      }
      this.initData();
    },
    methods: {
      initData () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        if( userInfo.Name!='' ){
           this.ownerName=userInfo.Name;
           this.isdisabled=true;
           console.log(userInfo.Name)
           console.log(this.isdisabled)
        }
        if( userInfo.Telephone ){ this.ownerPhone=userInfo.Telephone }
        let carInfo=JSON.parse(localStorage.getItem('carInfo'));
        console.log(carInfo);
        if(carInfo!=null){
          this.ownerName=carInfo.Name;
          this.carBrand=carInfo.CarClass;
          this.carCard=carInfo.CarNumber;
          this.ownerCity=carInfo.City;
          this.ownerAdd=carInfo.Address;
          this.Longitude=carInfo.Longitude;
          this.Latitude=carInfo.Latitude;
          this.RefereePhone=carInfo.RefereePhone;
        }
      },
      async submitApply () {
        if( !this.ownerName ){
          this.flexible.showToast({
            content: '请输入车主姓名！'
          });
          return ;
        }
        if( !this.carBrand ){
          this.flexible.showToast({
            content: '请输入'
          });
          return ;
        }
        if (!this.carCard || (this.carCard.length != 7 && this.carCard.length != 8)) {
          this.flexible.showToast({
            content: "请填写车牌号！",
            duration: 2000
          });
          return false;
        }
        let data = {
          Name: this.ownerName,
          Telephone: this.ownerPhone,
          CarClass: this.carBrand,
          CarNumber: this.carCard,
          City: this.carCity,
          Address: this.carAddress,
          Longitude: this.Longitude,
          Latitude: this.Latitude,
          RefereePhone:this.RefereePhone
        };
        console.log(data);
        let res = await apply({
          data: data,
          isLoading: 1,
          loadContent: '正在提交信息...'
        });
        if( res.Code==100 ){
          this.showTypeOne=3;
          localStorage.removeItem("carInfo");
          localStorage.removeItem("shareCarAddress");
          localStorage.removeItem("shareCarCity");
        }
      },
      ChoiceCity(){
        let carInfo = {
          Name: this.ownerName,
          Telephone: this.ownerPhone,
          CarClass: this.carBrand,
          CarNumber: this.carCard,
          City: this.ownerCity,
          Address: this.ownerAdd,
          Longitude: this.Longitude,
          Latitude: this.Latitude,
          RefereePhone:this.RefereePhone
        }
        localStorage.setItem("carInfo", JSON.stringify(carInfo));
        this.$router.push({ path: "/shareCarCityList" });
      },
      ChoiceAddress(){
        let carInfo = {
          Name: this.ownerName,
          Telephone: this.ownerPhone,
          CarClass: this.carBrand,
          CarNumber: this.carCard,
          City: this.ownerCity,
          Address: this.ownerAdd,
          Longitude: this.Longitude,
          Latitude: this.Latitude,
          RefereePhone:this.RefereePhone
        }
        localStorage.setItem("carInfo", JSON.stringify(carInfo));
        this.$router.push({ path: "/selectAddress" });
      },
      gorent(){
        if(orderSource==17){
          window.webkit.messageHandlers.goHome.postMessage(null);
        }else if(orderSource==16){
          dfpanda.goHome();
        } 
      }
    }
  }
</script>
<!-- swiper-pagination-bullet swiper-pagination-bullet-active -->
<style lang="scss">
  .addcar .beforAdd .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 330px;
    height: 20px;
    text-align: center;
  }
  .beforAdd .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    width: 16px;
    height: 16px;
    background-color: #fff;
    opacity: 0.5;
    border-radius: 8px;
  }
  .beforAdd .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet-active {
    width: 36px;
    opacity: 1;
  }
</style>
<style lang="scss" scoped>
.addcar {
  &.heightestZindex { z-index: 2; }
  width: 100%;
  // height: 100%;
  // position: fixed;
  // top: 0;
  // left: 0;
  // overflow-y: auto;
  img {
    width: 100%;
  }
  .samllHeader {
    width: 100%;
    height: 110px;
    line-height: 110px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #fff;
    .backIcon {
      display: block;
      width: 40px;
      height: 40px;
      position: absolute;
      top: 35px;
      left: 35px;
      background-image: url("~@/assets/images/backIcon.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    .titleName {
      width: 100%;
      font-size: 32px;
      text-align: center;
      font-weight: normal;
    }
  }

  .addCarBox {
    width: 100%;
    height: 100%;
    // padding-top: 110px;
    background-color: #fff;
    position: relative;
    .addContent {
      width: 100%;
      padding-bottom: 20px;
      .carInfo {
        width: 100%;
        box-sizing:border-box;
        padding: 20px 52px 0;
        position: relative;
        background-color: #fff;
        top: -50px;
        border-radius: 20px 20px 0 0;
        .carItemTitle {
          width: 100%;
          height: 36px;
          line-height: 36px;
          border-left: 10px solid #FF8307;
          text-indent: 12px;
          color: #434343;
          font-size: 32px;
          margin-top: 30px;
          margin-bottom: 20px;
        }
        .carItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 25px;
          height: 70px;
          line-height: 70px;
          > h6 {
            font-size: 26px;
            color: #9F9F9F;
          }
          > p {
            // width: 420px;
            background-color: #EFEFEF;
            // padding: 0 40px;
            padding:0 30px 0 60px;
            &.hasIcon {
              // background: #EFEFEF url("~@/assets/images/rightArrow.png") no-repeat 380px center;
              background: #EFEFEF url("~@/assets/images/rightArrow.png") no-repeat right center;
              background-size: 32px auto;
            }
            > input {
              width: 100%;
              height: 70px;
              background-color: transparent;
              color: #000;
              font-size: 27px;
            }
          }
        }
      }
      .addSunmit {
        width: 650px;
        height: 90px;
        text-align: center;
        line-height: 90px;
        margin: 0 auto;
        background-color: #FF8307;
        color: #fff;
        font-size: 28px;
        border-radius: 45px;
      }
    }
  }
  .successBox {
    padding-top: 165px;
    text-align: center;
    font-size: 26px;
    .successBg {
      width: 240px;
    }
    .successTips {
      color: #FF8307;
    }
    .allTips {
      line-height: 90px;
      color: #9E9E9E;
    }
    .backBtn {
      margin: 100px auto 0;
      width: 460px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 32px;
      background-color: #FF8307;
      color: #fff;
      border-radius: 45px;
    }
  }
}
</style>